import React, { useContext, useState } from "react";
import style from "./serviceRequests.module.css";
import { DashboardContext } from "../../../../context/DashboardContext";

const ServiceRequests = () => {
  const {
    serviceRequests,
    loading,
    deleteServiceRequest,
    updateServiceRequest,
  } = useContext(DashboardContext);

  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({});

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      await deleteServiceRequest(id);
    }
  };

  const handleEditClick = (req) => {
    setEditingId(req.id);
    setFormData(req); // preload row data into inputs
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({});
  };

  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSave = async () => {
    await updateServiceRequest(editingId, formData);
    setEditingId(null);
    setFormData({});
  };

  if (loading) return <p className={style.loading}>Loading service requests...</p>;
  if (!serviceRequests || serviceRequests.length === 0)
    return <p className={style.empty}>No service requests found.</p>;

  return (
    <div className={style.wrapper}>
      <h2 className={style.heading}>Service Requests</h2>

      <div className={style.table}>
        <div className={`${style.row} ${style.headerRow}`}>
          <div className={style.cell}>Requested By</div>
          <div className={style.cell}>Service</div>
          <div className={style.cell}>Address</div>
          <div className={style.cell}>Created On</div>
          <div className={style.cell}>Status</div>
          <div className={style.cell}>Action</div>
        </div>

        {serviceRequests.map((req) => (
          <div key={req.id} className={style.row}>
            {editingId === req.id ? (
              <>
                <div className={style.cell}>
                  <input
                    value={formData.requestedBy}
                    onChange={(e) => handleChange(e, "requestedBy")}
                  />
                </div>
                <div className={style.cell}>
                  <input
                    value={formData.service}
                    onChange={(e) => handleChange(e, "service")}
                  />
                </div>
                <div className={style.cell}>
                  <input
                    value={formData.address}
                    onChange={(e) => handleChange(e, "address")}
                  />
                </div>
                <div className={style.cell}>
                  <input
                    value={formData.createdOn}
                    onChange={(e) => handleChange(e, "createdOn")}
                  />
                </div>
                <div className={style.cell}>
                  <select
                    value={formData.status}
                    onChange={(e) => handleChange(e, "status")}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>
                <div className={style.cell}>
                  <button className={style.actionBtn} onClick={handleSave}>
                    Save
                  </button>
                  <button
                    className={`${style.actionBtn} ${style.deleteBtn}`}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className={style.cell}>{req.requestedBy}</div>
                <div className={style.cell}>{req.service}</div>
                <div className={style.cell}>{req.address}</div>
                <div className={style.cell}>{req.createdOn}</div>
                <div
                  className={`${style.cell} ${style.status} ${
                    style[req.status.toLowerCase()]
                  }`}
                >
                  {req.status}
                </div>
                <div className={style.cell}>
                  <button
                    className={style.actionBtn}
                    onClick={() => handleEditClick(req)}
                  >
                    Edit
                  </button>
                  <button
                    className={`${style.actionBtn} ${style.deleteBtn}`}
                    onClick={() => handleDelete(req.id)}
                  >
                    Delete
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceRequests;
